<template>
  <div id="app">
    <div v-if="page==1">
      <Swipe />
      <MidBg />
      <!-- <p  style='margin:auto;padding:0 30px ;color:red;text-align:left;font-size: 3.44444vw;font-family:Roboto-Black, Roboto;font-weight: 900;'>Please do not trust any unknown websites which contain "free recharge" fake information. 4Fun never hold any "free recharge", " free 5G traffic" or "winning" activities.</p> -->
      <img src="./assets/imgs/alert.png" style="width:97.22222vw;"/>
      <br/>
      <br/>
      <WaterFall />
      <Button v-if="showBottomBtn" position="bottom"/>
      <div style="margin-top:20px;color:#C0C0C0;font-size:5px">Copyright © 2020 SPREADFUN PTE. LTD. All rights reserved.</div>
    </div>
    <GPPage v-if="page==2" />
  </div>
</template>

<script>

import "./assets/css/base.scss";
import Swipe from "./components/Swipe.vue";
import MidBg from "./components/MidBg.vue";
import WaterFall from "./components/WaterFall";
import Button from "./components/Button";
import GPPage from "./components/gppage";
export const getQueryString = (name,url) => {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = (url||window.location.search.substr(1)).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
 }
export default {
  name: "app",
  components: {
    Swipe,
    MidBg,
    WaterFall,
    Button,
    GPPage
  },
  computed: {
    page() {
      return this.$store.state.page;
    },
    showBottomBtn() {
      return this.$store.state.bottomButton;
    }
  },
  mounted() {
    let search=location.search;
        let flag=getQueryString('flag')||0;
        if(!flag){
            let url;
            if(search){
                url=location.href+'&flag=1';
            }else{
                url=location.href+'?flag=1';
            }
            history.pushState(null, null, url);
        }
    const that=this
    window.onpopstate = function() {
      let link=that.$store.state.adUrl || 'http://draw.4fun.mobi/';
      window._czc.push(['_trackEvent', 'backad', link]);
      setTimeout(() => {
        location.href=link;
      }, 300);
    };
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Roboto", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-bottom: 20px;
}
#cnzz_stat_icon_1262229158 {
  opacity: 0;
}
</style>
